module.exports = __webpack_public_path__ + "static/img/pic-02.846fdce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-02.png
// module id = uEbN
// module chunks = 1